import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Typography } from '@mui/material';
import { tokens } from '../../theme';
import { useCopyToClipboard } from '../CopyButton';
import type { CommandBlockProps } from './types';

/**
 * A command, ready to paste — and to copy without retyping. A rejected clipboard
 * renders `Copy failed` rather than throwing, which the shared hook handles.
 */
export const CommandBlock = ({ children }: CommandBlockProps) => {
  const { status, copy } = useCopyToClipboard(children);

  return (
    <Box sx={{ position: 'relative' }}>
      <Typography
        component="pre"
        sx={{
          fontFamily: tokens.fontFamily.mono,
          fontSize: 13,
          lineHeight: 1.6,
          backgroundColor: 'surface.sunken',
          borderRadius: `${String(tokens.radius.md)}px`,
          padding: 4,
          paddingRight: 10,
          margin: 0,
          overflowX: 'auto',
        }}
      >
        {children}
      </Typography>

      <Box sx={{ position: 'absolute', top: 4, right: 4, display: 'flex', alignItems: 'center', gap: 1 }}>
        {status !== 'idle' && (
          <Typography variant="body2" component="span" sx={{ fontSize: 11, color: 'text.secondary' }}>
            {status === 'copied' ? 'Copied' : 'Copy failed'}
          </Typography>
        )}
        <IconButton aria-label="Copy command" onClick={copy} size="small">
          <ContentCopyIcon aria-hidden fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
